/* eslint-disable import/order */
// SaleSpace
// import { ChatPage } from 'containers/App/Chat/Loadable';
import { BannerListPage } from 'containers/Branding/DecorationWebsite/BannerPage/Loadable';
import { EmployeeCreatePage } from 'containers/Branding/Employee/Employee/CreatePage/Loadable';
import { EmployeeDetailPage } from 'containers/Branding/Employee/Employee/DetailPage/Loadable';
import { EmployeeListPage } from 'containers/Branding/Employee/Employee/ListPage/Loadable';
import { ProcessCreatePage } from 'containers/ProductionManager/Process/CreatePage/Loadable';
import { ProcessDetailPage } from 'containers/ProductionManager/Process/DetailPage/Loadable';
import { ProcessListPage } from 'containers/ProductionManager/Process/ListPage/Loadable';
import { ProductObjectCreatePage } from 'containers/ProductionManager/ProductObject/CreatePage/Loadable';
import { ProductObjectDetailPage } from 'containers/ProductionManager/ProductObject/DetailPage/Loadable';
import { ProductObjectListPage } from 'containers/ProductionManager/ProductObject/ListPage/Loadable';
import { SectionCreatePage } from 'containers/ProductionManager/ProductObject/Section/CreatePage/Loadable';
import { WithType as WithProductObjectType } from 'containers/ProductionManager/ProductObject/components';
import { CoBuyCreatePage } from 'containers/SaleManager/Discount/CoBuy/CreatePage/Loadable';
import { CoBuyDetailPage } from 'containers/SaleManager/Discount/CoBuy/DetailPage/Loadable';
import { CoBuyListPage } from 'containers/SaleManager/Discount/CoBuy/ListPage/Loadable';
import { CoBuyReportPage } from 'containers/SaleManager/Discount/CoBuy/ReportPage/Loadable';
import { ComboCreatePage } from 'containers/SaleManager/Discount/Combo/CreatePage/Loadable';
import { ComboListPage } from 'containers/SaleManager/Discount/Combo/ListPage/Loadable';
import { FreeshipCouponCreatePage } from 'containers/SaleManager/Marketing/FreeshipCoupon/CreatePage/Loadable';
import { FreeshipCouponListPage } from 'containers/SaleManager/Marketing/FreeshipCoupon/ListPage/Loadable';
import { FreeshipCouponUpdatePage } from 'containers/SaleManager/Marketing/FreeshipCoupon/UpdatePage/Loadable';
import { MyCouponPage } from 'containers/SaleManager/Marketing/MyCoupon/Loadable';
import { ShopCouponCreatePage } from 'containers/SaleManager/Discount/ShopCoupon/CreatePage/Loadable';
import { ShopCouponDetailPage } from 'containers/SaleManager/Discount/ShopCoupon/DetailPage/Loadable';
import { ShopCouponListPage } from 'containers/SaleManager/Discount/ShopCoupon/ListPage/Loadable';
import { ProductCreatePage } from 'containers/ProductionManager/ProductManager/Product/CreatePage/Loadable';
import { ProductDetailPage } from 'containers/ProductionManager/ProductManager/Product/DetailPage/Loadable';
import { ProductListPage } from 'containers/ProductionManager/ProductManager/Product/ListPage/Loadable';
import { BranchListPage } from 'containers/Branding/Store/Branch/ListPage/Loadable';
import { CouponCreatePage } from 'containers/Branding/Store/Coupon/CreatePage/Loadable';
import { DashboardPage } from 'containers/Overview/Dashboard/Loadable';
import { SaleSpaceFilePage } from 'containers/Branding/DecorationWebsite/Library/File/Loadable';
import { GalleryPage } from 'containers/Branding/DecorationWebsite/Library/GalleryPage/Loadable';
import { OrderDetailPage } from 'containers/WarehouseOperation/OrderOperation/Order/Overview/DetailPage/Loadable';
import { TransactionPage } from 'containers/WarehouseOperation/WorkSpace/Transaction/Loadable';

// FarmEntity

import { SaleEntityDecorationPage } from '../../Branding/DecorationWebsite/WebsitePage/Loadable';

// StoreEntity

import { BranchCreatePage } from 'containers/Branding/Store/Branch/CreatePage/Loadable';
import { BranchDetailPage } from 'containers/Branding/Store/Branch/DetailPage/Loadable';
import { CouponDetailPage } from 'containers/Branding/Store/Coupon/DetailPage/Loadable';

// CollaboratorEntity

// Marketing

// Chat

// Commons
import { NoticeLinkedListPage } from '../Notification/NoticeLinkedListPage/Loadable';
import { NoticeOrderListPage } from '../Notification/NoticeOrderListPage/Loadable';
import { NoticeOverViewListPage } from '../Notification/NoticeOverViewListPage/Loadable';
import { NoticeRequestOrderListPage } from '../Notification/NoticeRequestOrderListPage/Loadable';
import { NoticeSystemListPage } from '../Notification/NoticeSystemListPage/Loadable';

import { EntityMaterialDetailPage } from 'containers/ProductionManager/ProductManager/EntityMaterial/DetailPage/Loadable';
import { EntityMaterialListPage } from 'containers/ProductionManager/ProductManager/EntityMaterial/ListPage/Loadable';

import { EntityMaterialCreatePage } from 'containers/ProductionManager/ProductManager/EntityMaterial/CreatePage/Loadable';
import { EntityMaterialCategoryListPage } from 'containers/ProductionManager/ProductManager/EntityMaterialCategory/ListPage/Loadable';
import { SyncEntityProcessPage } from 'containers/ProductionManager/Process/SyncPage/Loadable';
import { AddDiaryMobile } from 'containers/ProductionManager/ProductObject/Diary/AddDiaryMobile/Loadable';
import { ProductObjectMobile } from 'containers/ProductionManager/ProductObject/ProductObjectMobile/Loadable';
import { SectionUpdatePage } from 'containers/ProductionManager/ProductObject/Section/UpdatePage/Loadable';
import { SyncEntityProductObjectPage } from 'containers/ProductionManager/ProductObject/SyncPage/Loadable';
import { BankAccountPage } from 'containers/Branding/BusinessInformation/BankAccountPage/Loadable';
import { ConnectZaloCreate } from 'containers/Branding/Application/ConnectZaloPage/ConnectZaloCreate/Loadable';
import { ConnectZaloUpdate } from 'containers/Branding/Application/ConnectZaloPage/ConnectZaloUpdate/Loadable';
import { ConnectZaloPage } from 'containers/Branding/Application/ConnectZaloPage/Loadable';
import { DeliveryFeeSettingPage } from 'containers/SaleManager/Policy/DeliveryFeeSettingPage/Loadable';
import { DistanceShippingFeePage } from 'containers/SaleManager/Policy/ShippingFeePolicy/Loadable';
import { EntityBalanceReportCreatePage } from 'containers/Branding/Farm/Setting/EntityBalanceReportPage/EntityBalanceReportCreatePage/Loadable';
import { EntityBalanceReportUpdatePage } from 'containers/Branding/Farm/Setting/EntityBalanceReportPage/EntityBalanceReportUpdatePage/Loadable';
import { EntityBalanceReportPage } from 'containers/Branding/Farm/Setting/EntityBalanceReportPage/Loadable';
import { EntityQuantityReportPage } from 'containers/Branding/Farm/Setting/EntityQuantityReportPage/Loadable';
import { EntityQuantityReportCreatePage } from 'containers/Branding/Farm/Setting/EntityQuantityReportPage/EntityQuantityReportCreatePage/Loadable';
import { EntityQuantityReportUpdatePage } from 'containers/Branding/Farm/Setting/EntityQuantityReportPage/EntityQuantityReportUpdatePage/Loadable';
import { EntityReportCreatePage } from 'containers/Branding/Farm/Setting/EntityReportPage/EntityReportCreatePage';
import { EntityReportUpdatePage } from 'containers/Branding/Farm/Setting/EntityReportPage/EntityReportUpdatePage';
import { EntityReportPage } from 'containers/Branding/Farm/Setting/EntityReportPage/Loadable';
import { NotifyEntityCreatePage } from 'containers/Branding/Farm/Setting/NotifyEntityCreatePage/Loadable';
import { NotifyCustomerPage } from 'containers/Branding/Farm/Setting/NotifyEntityPage/Loadable';
import { NotifyEntityUpdatePage } from 'containers/Branding/Farm/Setting/NotifyEntrityUpdatePage/Loadable';
import { ShippingLocationPage } from 'containers/Branding/Farm/Setting/ShippingLocationPage/Loadable';
import { ZaloNotificationSettingPage } from 'containers/Branding/Application/ZaloNotificationSettingPage/Loadable';
import { ZaloNotificationSettingCreate } from 'containers/Branding/Application/ZaloNotificationSettingPage/ZaloNotificationSettingCreate/Loadable';
import { ZaloNotificationSettingUpdate } from 'containers/Branding/Application/ZaloNotificationSettingPage/ZaloNotificationSettingUpdate/Loadable';
import { CreateFormPage } from 'containers/App/Help/ContactForm/CreatePage/Loadable';
import { FormPage } from 'containers/App/Help/ContactForm/ListPage/Loadable';
import { GuideDetailPage } from 'containers/App/Help/GuideDetailPage/Loadable';
import { GuidePage } from 'containers/App/Help/GuidePage/Loadable';
import { GuidePartPage } from 'containers/App/Help/GuidePartPage/Loadable';
import { HelpPage } from 'containers/App/Help/HelpPage/Loadable';
import { CreateMeetingPage } from 'containers/App/Help/Meeting/CreatePage/Loadable';
import { MeetingPage } from 'containers/App/Help/Meeting/ListPage/Loadable';
import { QuestionPage } from 'containers/App/Help/QuestionPage/Loadable';
import { ComboDetailPage } from 'containers/SaleManager/Discount/Combo/DetailPage/Loadable';
import { CreateWholesaleMenuPage } from 'containers/SaleManager/Marketing/WholesaleDigitalMenu/CreatePage/Loadable';
import { DetailWholesaleMenuPage } from 'containers/SaleManager/Marketing/WholesaleDigitalMenu/DetailPage/Loadable';
import { WholesaleDigitalMenuPage } from 'containers/SaleManager/Marketing/WholesaleDigitalMenu/ListPage/Loadable';
import { SyncMenuProductPage } from 'containers/SaleManager/Marketing/WholesaleDigitalMenu/SyncPage/Loadable';
import { SubProductListPage } from 'containers/ProductionManager/ProductManager/Product/SubProduct/ListPage/Loadable';
import { SyncEntityProductDiaryPage } from 'containers/ProductionManager/ProductManager/Product/SyncEntityProductDiaryPage/Loadable';
import { SyncProductPage } from 'containers/ProductionManager/ProductManager/Product/SyncPage/Loadable';
import { StampListPage } from 'containers/ProductionManager/Stamp/pages/ListPage/Loadable';
import { BillingPage } from 'containers/SaleManager/Sale/Bill/Loadable';
import { UpdateBillingPage } from 'containers/SaleManager/Sale/UpdateBilling/Loadable';
import { CategoriesPage } from 'containers/SaleManager/Sale/Debt/CategoriesPage/Loadable';
import { DebtStatisticPage } from 'containers/SaleManager/Sale/Debt/DebtStatisticPage/Loadable';
import { ReceiptsPage } from 'containers/SaleManager/Sale/Debt/ReceiptsPage/Loadable';
import { ReturnPage } from 'containers/SaleManager/Sale/Debt/ReturnPage/Loadable';
import { PartnerCRMPage } from 'containers/WarehouseOperation/WorkSpace/Partner/CRMPage/Loadable';
import { PartnerDetailPage } from 'containers/WarehouseOperation/WorkSpace/Partner/DetailPage/Loadable';
import { PartnerPage } from 'containers/SaleManager/Partner/PartnerPage/Loadable';
import { PartnerRequestPage } from 'containers/WarehouseOperation/WorkSpace/Partner/ListPage/RequestPage/Loadable';
import { PartnerWaitForApprovalPage } from 'containers/WarehouseOperation/WorkSpace/Partner/ListPage/WaitForApprovalPage/Loadable';
import { PartnerWaitingForApprovalPage } from 'containers/WarehouseOperation/WorkSpace/Partner/ListPage/WaitingForApprovalPage/Loadable';
import { CreatePricePolicyPage } from 'containers/SaleManager/Policy/PricePolicy/CreatePage/Loadable';
import { DetailPricePolicyPage } from 'containers/SaleManager/Policy/PricePolicy/DetailPage/Loadable';
import { PricePolicyPage } from 'containers/SaleManager/Policy/PricePolicy/ListPage/Loadable';
import { CreateProposalPolicyPage } from 'containers/SaleManager/Policy/ProposalPolicy/CreatePage/Loadable';
import { DetailProposalPolicyPage } from 'containers/SaleManager/Policy/ProposalPolicy/DetailPage/Loadable';
import { ProposalPolicyPage } from 'containers/SaleManager/Policy/ProposalPolicy/ListPage/Loadable';
import { BalancePage } from 'containers/WarehouseOperation/OrderOperation/Balance/Loadable';
import { SettingBuyingHistoryPage } from 'containers/WarehouseOperation/OperationalSetting/SettingBuyingHistoryPage/Loadable';
import { SettingBuyingPage } from 'containers/WarehouseOperation/OperationalSetting/SettingPage/Loadable';
import { OrdersToChainSuppliersPage } from 'containers/WarehouseOperation/Purchase/OrdersToChainSuppliers/Loadable';
import { AssignTaskCreate } from 'containers/WarehouseOperation/OperationalTool/AssignTaskPage/AssignTaskCreate/Loadable';
import { AssignTaskUpdate } from 'containers/WarehouseOperation/OperationalTool/AssignTaskPage/AssignTaskUpdate/Loadable';
import { AssignTaskPage } from 'containers/WarehouseOperation/OperationalTool/AssignTaskPage/Loadable';
import { EntityShippingCreatePage } from 'containers/WarehouseOperation/OperationalTool/EntityShippingList/EntityShippingCreate/Loadable';
import { EntityShippingDetailPage } from 'containers/WarehouseOperation/OperationalTool/EntityShippingList/EntityShippingDetail/Loadable';
import { EntityShippingListPage } from 'containers/WarehouseOperation/OperationalTool/EntityShippingList/Loadable';
import { ForecastQuantityPage } from 'containers/WarehouseOperation/OrderOperation/Sale/ForecastQuantityPage/Loadable';
import { OrderClosingPage } from 'containers/WarehouseOperation/OrderOperation/Sale/OrderClosingPage/Loadable';
import { OrderPendingBuySalePage } from 'containers/WarehouseOperation/OrderOperation/Sale/OrderPendingBuySalePage/Loadable';
import { ReportQuantityPage } from 'containers/WarehouseOperation/OrderOperation/Sale/ReportQuantityPage/Loadable';
import { SettingForecastPage } from 'containers/WarehouseOperation/OperationalSetting/SettingForecast/Loadable';
import { SettingForecastHistoryPage } from 'containers/WarehouseOperation/OperationalSetting/SettingForecastHistoryPage/Loadable';
import { DebtReportPage } from 'containers/Overview/Report/DebtReportPage/Loadable';
import { RevenueReportPage } from 'containers/Overview/Report/RevenueReportPage/Loadable';
import { SaleReportPage } from 'containers/Overview/Report/SaleReportPage/Loadable';
import { CollaboratorPage } from 'containers/WarehouseOperation/WorkSpace/Statistic/Collaborator/Loadable';
import { StatisticProductPage } from 'containers/Overview/Statistic/ProductStatisticPage/Loadable';
import { ContactPage } from '../ContactPage/Loadable';
import { FeaturePage } from '../FeaturePage/Loadable';
import { ProductionPlanListPage } from 'containers/ProductionManager/ProductionPlan/ListPage/Loadable';
import { ProductionPlanCreatePage } from 'containers/ProductionManager/ProductionPlan/CreatePage/Loadable';
import { LoanPage } from '../LoanPage/Loadable';
import { MenuPage } from '../MenuPage/Loadable';
import { ProfilePage } from '../ProfilePage/Loadable';
import { ProductionPlanReportQuantityPage } from 'containers/ProductionManager/ProductionPlan/ReportQuantityPage/Loadable';
import { AreaDetailPage } from 'containers/ProductionManager/Area/DetailPage/Loadable';
import { AreaCreatePage } from 'containers/ProductionManager/Area/CreatePage/Loadable';
import { AreaListPage } from 'containers/ProductionManager/Area/ListPage/Loadable';
import { SyncEntityAreaPage } from 'containers/ProductionManager/Area/SyncPage/Loadable';
import { EntityCategoryPage } from 'containers/ProductionManager/ProductManager/EntityCategory/Loadable';
import { ContactInformationPage } from 'containers/Branding/BusinessInformation/ContactInformationPage/Loadable';
import { ContactToolPage } from 'containers/Branding/BusinessInformation/ContactToolPage/Loadable';
import { CertificationPage } from 'containers/Branding/DecorationWebsite/CertificationPage/Loadable';
import { SEOWebsitePage } from 'containers/Branding/DecorationWebsite/SEOWebsitePage/Loadable';
import { BranchPage } from 'containers/SaleManager/Partner/BranchPage/Loadable';
import { WarehousePage } from 'containers/ProductionManager/Supplier/WarehousePage/Loadable';
import { SupplierPage } from 'containers/ProductionManager/Supplier/SupplierPage/Loadable';
import { CustomDomainPage } from 'containers/Branding/BusinessModel/CustomDomainPage/Loadable';
import { EnterpriseSequenceDiagramPage } from 'containers/Branding/BusinessModel/EnterpriseSequenceDiagramPage/Loadable';
import { SupplierOverviewPage } from 'containers/ProductionManager/Supplier/SupplierOverviewPage/Loadable';
import { PartnerOverviewPage } from 'containers/SaleManager/Partner/PartnerOverviewPage/Loadable';
import { ProductionPlanUpdatePage } from 'containers/ProductionManager/ProductionPlan/UpdatePage/Loadable';
import { PricePolicyOverviewPage } from 'containers/SaleManager/Policy/PricePolicyOverviewPage/Loadable';
import { BuyingOrderPage } from 'containers/WarehouseOperation/Purchase/Buying/BuyingOrderPage/Loadable';
import { SyncEntitySectionPage } from 'containers/ProductionManager/ProductObject/Section/SyncPage/Loadable';
import { SalePOSPage } from 'containers/WarehouseOperation/OrderOperation/SalePOSPage/Loadable';
import { ConfigPage } from '../ConfigPage/Loadable';
import { CollectionPage } from 'containers/SaleManager/Sale/Debt/CollectionPage/Loadable';
import { PaymentPage } from 'containers/SaleManager/Sale/Debt/PaymentPage/Loadable';
import { checkPermission } from 'utils';
import { AssignPurchaseTaskPage } from 'containers/WarehouseOperation/Purchase/Buying/AssignPurchaseTaskPage/Loadable';
import { AssignPurchaseTaskCreate } from 'containers/WarehouseOperation/Purchase/Buying/AssignPurchaseTaskPage/AssignPurchaseTaskCreate/Loadable';
import { AssignPurchaseTaskUpdate } from 'containers/WarehouseOperation/Purchase/Buying/AssignPurchaseTaskPage/AssignPurchaseTaskUpdate/Loadable';
import { TaskPage } from 'containers/ProductionManager/ProductionPlan/TaskPage/Loadable';
import { DiscountListPage } from 'containers/SaleManager/Discount/Discount/ListPage/Loadable';
import { DiscountCreatePage } from 'containers/SaleManager/Discount/Discount/CreatePage/Loadable';
import { DiscountSettingPage } from 'containers/SaleManager/Discount/DiscountSetting/Loadable';
import { DiscountDetailPage } from 'containers/SaleManager/Discount/Discount/DetailPage/Loadable';
import { PartnerSegmentPage } from 'containers/SaleManager/Partner/PartnerSegmentPage/ListPage/Loadable';
import { SupplierSegmentListPage } from 'containers/ProductionManager/Supplier/SupplierSegmentPage/ListPage/Loadable';
import { BlogListPage } from 'containers/Branding/Blog/Blog/ListPage/Loadable';
import { BlogCategoryListPage } from 'containers/Branding/Blog/BlogCategory/ListPage/Loadable';
import { BlogCreatePage } from 'containers/Branding/Blog/Blog/CreatePage/Loadable';
import { BlogDetailPage } from 'containers/Branding/Blog/Blog/DetailPage/Loadable';
import { EntityStockReportPage } from 'containers/Branding/Farm/Setting/EntityStockReportPage';
import { EntityStockReportUpdatePage } from 'containers/Branding/Farm/Setting/EntityStockReportPage/EntityStockReportUpdatePage';
import { EntityStockReportCreatePage } from 'containers/Branding/Farm/Setting/EntityStockReportPage/EntityStockReportCreatePage';
import { ConnectLarkPage } from 'containers/Branding/Farm/Setting/ConnectLarkPage/Loadable';
import { ConnectLarkCreate } from 'containers/Branding/Farm/Setting/ConnectLarkPage/ConnectLarkCreate/Loadable';
import { ConnectLarkUpdate } from 'containers/Branding/Farm/Setting/ConnectLarkPage/ConnectZaloUpdate/Loadable';
import { SettingBusinessPage } from 'containers/WarehouseOperation/OperationalSetting/SettingBusiness/Loadable';
import { CustomerPage } from 'containers/SaleManager/Customer/CustomerPage/ListPage/Loadable';
import { CustomerCreatePage } from 'containers/SaleManager/Customer/CustomerPage/CreatePage/Loadable';
import { EntityDiscountReportPage } from 'containers/Branding/Farm/Setting/EntityDiscountReportPage/Loadable';
import { EntityDiscountReportUpdatePage } from 'containers/Branding/Farm/Setting/EntityDiscountReportPage/EntityDiscountReportUpdatePage/Loadable';
import { EntityDiscountReportCreatePage } from 'containers/Branding/Farm/Setting/EntityDiscountReportPage/EntityDiscountReportCreatePage/Loadable';
import { CustomerSegmentPage } from 'containers/SaleManager/Customer/CustomerSegmentPage/ListPage/Loadable';
import { CustomerDetailPage } from 'containers/SaleManager/Customer/CustomerPage/DetailPage/Loadable';
import { CustomerCRMPage } from 'containers/SaleManager/Customer/CustomerPage/CRMPage/Loadable';
import { SaleContactPage } from 'containers/SaleManager/SaleContact/SaleContactPage/ListPage/Loadable';
import { StockListPage } from 'containers/WarehouseOperation/Stock/StockPage/ListPage/Loadable';
import { StockAdjustmentPage } from 'containers/WarehouseOperation/Stock/StockAdjustmentPage/ListPage/Loadable';
import { StockAdjustmentCreatePage } from 'containers/WarehouseOperation/Stock/StockAdjustmentPage/CreatePage/Loadable';
import { StockAdjustmentDetailPage } from 'containers/WarehouseOperation/Stock/StockAdjustmentPage/DetailPage/Loadable';
import { InventoryProductDetailPage } from 'containers/WarehouseOperation/Stock/InventoryProductPage/DetailPage/Loadable';
import { InventoryProductListPage } from 'containers/WarehouseOperation/Stock/InventoryProductPage/ListPage/Loadable';

const ProductObjectListPageWithType = WithProductObjectType(
  ProductObjectListPage
);
const ProductObjectCreatePageWithType = WithProductObjectType(
  ProductObjectCreatePage
);
const ProductObjectDetailPageWithType = WithProductObjectType(
  ProductObjectDetailPage
);
const SectionCreatePageWithType = WithProductObjectType(SectionCreatePage);
const SectionUpdatePageWithType = WithProductObjectType(SectionUpdatePage);

export interface RouteProps {
  path?: string;
  exact?: boolean;
  component: any;
  render?: (props: any) => void;
}

export const routes = (canCreateNewProduct: boolean, permissions: any) => [
  // commons
  {
    label: 'Vay vốn',
    path: `/order`,
    exact: true,
    component: LoanPage,
  },
  {
    label: 'Vay vốn',
    path: `/feature`,
    exact: true,
    component: FeaturePage,
  },
  {
    label: 'Hỗ trợ',
    path: `/help`,
    exact: true,
    component: HelpPage,
  },
  {
    label: 'Câu hỏi',
    path: `/help/question/:id`,
    exact: true,
    component: QuestionPage,
  },
  {
    label: 'Hướng dẫn',
    path: `/help/guide`,
    exact: true,
    component: GuidePage,
  },
  {
    label: 'Hướng dẫn',
    path: `/help/guide/:part`,
    exact: true,
    component: GuidePartPage,
  },
  {
    label: 'Hướng dẫn',
    path: `/help/guide/:part/:id`,
    exact: true,
    component: GuideDetailPage,
  },
  {
    label: 'Lịch hẹn',
    path: `/help/meeting`,
    exact: true,
    component: MeetingPage,
  },
  {
    label: 'Lịch hẹn',
    path: `/help/meeting/create`,
    exact: true,
    component: CreateMeetingPage,
  },
  {
    label: 'Biểu mẫu',
    path: `/help/form`,
    exact: true,
    component: FormPage,
  },
  {
    label: 'Biểu mẫu',
    path: `/help/form/create`,
    exact: true,
    component: CreateFormPage,
  },
  {
    label: 'Menu',
    path: `/menu`,
    component: MenuPage,
  },
  {
    label: 'Liên hệ',
    path: `/contact`,
    component: ContactPage,
  },
  {
    label: 'Tài khoản',
    path: `/profile`,
    component: ProfilePage,
  },
  {
    label: 'Thông báo',
    path: `/notification/overview/list`,
    component: NoticeOverViewListPage,
  },
  {
    label: 'Thông báo/Thông báo liên kết',
    path: `/notification/linked/list`,
    component: NoticeLinkedListPage,
  },
  {
    label: 'Thông báo/Thông báo hệ thống',
    path: `/notification/system/list`,
    component: NoticeSystemListPage,
  },
  {
    label: 'Thông báo/Thông báo đơn hàng',
    path: `/notification/order/list`,
    component: NoticeOrderListPage,
  },
  {
    label: 'Thông báo/Yêu cầu mua hàng',
    path: `/notification/request-order/list`,
    component: NoticeRequestOrderListPage,
  },
  // order detail
  {
    label: '',
    path: `/order/:id/detail`,
    component: OrderDetailPage,
  },
  {
    label: 'Thiết lập/Thông báo nội bộ',
    path: `/settings/notify-customer/:id/update`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingNotify',
      feature: 'settingNotifySlack',
    }),
    component: NotifyEntityUpdatePage,
  },
  {
    label: 'Thiết lập/Thông báo nội bộ',
    path: `/settings/notify-customer/create`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingNotify',
      feature: 'settingNotifySlack',
    }),
    component: NotifyEntityCreatePage,
  },
  {
    label: 'Thiết lập/Thông báo nội bộ',
    path: `/settings/notify-customer/list`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingNotify',
      feature: 'settingNotifySlack',
    }),
    component: NotifyCustomerPage,
  },
  {
    label: 'Thiết lập/Báo cáo nhận đơn',
    path: `/settings/entity-report/create`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportReceiveOrder',
    }),
    component: EntityReportCreatePage,
  },
  {
    label: 'Thiết lập/Báo cáo nhận đơn',
    path: `/settings/entity-report/:id/update`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportReceiveOrder',
    }),
    component: EntityReportUpdatePage,
  },
  {
    label: 'Thiết lập/Báo cáo nhận đơn',
    path: `/settings/entity-report/list`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportReceiveOrder',
    }),
    component: EntityReportPage,
  },
  {
    label: 'Thiết lập/Báo cáo cân bằng',
    path: `/settings/balance-report/create`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportBalance',
    }),
    component: EntityBalanceReportCreatePage,
  },
  {
    label: 'Thiết lập/Báo cáo cân bằng',
    path: `/settings/balance-report/:id/update`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportBalance',
    }),
    component: EntityBalanceReportUpdatePage,
  },
  {
    label: 'Thiết lập/Báo cáo cân bằng',
    path: `/settings/balance-report/list`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportBalance',
    }),
    component: EntityBalanceReportPage,
  },
  {
    label: 'Thiết lập/Báo cáo sản lượng',
    path: `/settings/quantity-report/create`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportQuantity',
    }),
    component: EntityQuantityReportCreatePage,
  },
  {
    label: 'Thiết lập/Báo cáo sản lượng',
    path: `/settings/quantity-report/:id/update`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportQuantity',
    }),
    component: EntityQuantityReportUpdatePage,
  },
  {
    label: 'Thiết lập/Báo cáo sản lượng',
    path: `/settings/quantity-report/list`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportQuantity',
    }),
    component: EntityQuantityReportPage,
  },
  {
    label: 'Thiết lập/Báo cáo tồn kho/Kết nối Lark',
    path: `/settings/stock-report/connect/create`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportQuantity',
    }),
    component: ConnectLarkCreate,
  },
  {
    label: 'Thiết lập/Báo cáo tồn kho/Kết nối Lark',
    path: `/settings/stock-report/connect/:id/update`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportQuantity',
    }),
    component: ConnectLarkUpdate,
  },

  {
    label: 'Thiết lập/Báo cáo tồn kho/Kết nối Lark',
    path: `/settings/stock-report/connect/list`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportQuantity',
    }),
    component: ConnectLarkPage,
  },
  {
    label: 'Thiết lập/Báo cáo tồn kho',
    path: `/settings/stock-report/create`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportQuantity',
    }),
    component: EntityStockReportCreatePage,
  },
  {
    label: 'Thiết lập/Báo cáo tồn kho',
    path: `/settings/stock-report/:id/update`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportQuantity',
    }),
    component: EntityStockReportUpdatePage,
  },
  {
    label: 'Thiết lập/Báo cáo tồn kho',
    path: `/settings/stock-report/list`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportQuantity',
    }),
    component: EntityStockReportPage,
  },

  {
    label: 'Thiết lập/Báo cáo chiết khấu CTV/Kết nối Lark',
    path: `/settings/discount-collaborator-report/connect/list`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportQuantity',
    }),
    component: ConnectLarkPage,
  },
  {
    label: 'Thiết lập/Báo cáo chiết khấu CTV',
    path: `/settings/discount-collaborator-report/create`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportQuantity',
    }),
    component: EntityDiscountReportCreatePage,
  },
  {
    label: 'Thiết lập/Báo cáo chiết khấu CTV',
    path: `/settings/discount-collaborator-report/:id/update`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportQuantity',
    }),
    component: EntityDiscountReportUpdatePage,
  },
  {
    label: 'Thiết lập/Báo cáo chiết khấu CTV',
    path: `/settings/discount-collaborator-report/list`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportQuantity',
    }),
    component: EntityDiscountReportPage,
  },
  {
    label: 'Thiết lập/Báo cáo chiết khấu CTV/Kết nối Lark',
    path: `/settings/discount-collaborator-report/connect/create`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportQuantity',
    }),
    component: ConnectLarkCreate,
  },
  {
    label: 'Thiết lập/Báo cáo chiết khấu CTV/Kết nối Lark',
    path: `/settings/discount-collaborator-report/connect/:id/update`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingReport',
      feature: 'settingReportQuantity',
    }),
    component: ConnectLarkUpdate,
  },

  {
    label: 'Thiết lập/Thông báo Zalo/Kết nối Zalo',
    path: `/settings/zalo-notification/connect/list`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingNotify',
      feature: 'settingNotifyZalo',
    }),
    component: ConnectZaloPage,
  },
  {
    label: 'Thiết lập/Thông báo Zalo/Kết nối Zalo',
    path: `/settings/zalo-notification/connect/create`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingNotify',
      feature: 'settingNotifyZalo',
    }),
    component: ConnectZaloCreate,
  },
  {
    label: 'Thiết lập/Thông báo Zalo/Kết nối Zalo',
    path: `/settings/zalo-notification/connect/:id/update`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingNotify',
      feature: 'settingNotifyZalo',
    }),
    component: ConnectZaloUpdate,
  },
  {
    label: 'Thiết lập/Thông báo Zalo',
    path: `/settings/zalo-notification/create`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingNotify',
      feature: 'settingNotifyZalo',
    }),
    component: ZaloNotificationSettingCreate,
  },
  {
    label: 'Thiết lập/Thông báo Zalo',
    path: `/settings/zalo-notification/list`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingNotify',
      feature: 'settingNotifyZalo',
    }),
    component: ZaloNotificationSettingPage,
  },
  {
    label: 'Thiết lập/Thông báo Zalo',
    path: `/settings/zalo-notification/:id/update`,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingNotify',
      feature: 'settingNotifyZalo',
    }),
    component: ZaloNotificationSettingUpdate,
  },
  {
    label: 'Thống kê',
    path: '/statistics/overview',
    component: DashboardPage,
  },
  {
    label: 'Thống kê',
    exact: true,
    path: '/statistics',
    component: DashboardPage,
  },
  {
    label: 'Thống kê doanh thu',
    path: '/statistics/revenue',
    component: DashboardPage,
  },
  {
    label: 'Thống kê sản lượng',
    path: '/production-plan/report-quantity',
    hidding:
      !checkPermission({
        permissions,
        module: 'manufacturer',
        groupFeature: 'manufacturerUtil',
        feature: 'manufacturerUtilStatisticsQuantity',
      }) &&
      !checkPermission({
        permissions,
        module: 'overview',
        groupFeature: 'report',
        feature: 'statisticsQuantity',
      }),
    component: ProductionPlanReportQuantityPage,
  },
  {
    label: 'Công nhật',
    path: '/production-plan/task',
    component: TaskPage,
  },
  {
    label: 'Báo cáo kho',
    path: '/statistics/product',
    component: StatisticProductPage,
  },
  {
    label: 'Đại sứ bán hàng',
    path: '/statistics/collaborator',
    component: CollaboratorPage,
  },
  {
    label: 'Hóa đơn',
    path: '/debt/billing',
    exact: true,
    hidding: !checkPermission({
      permissions,
      module: 'accounting',
      groupFeature: 'bill',
      feature: 'billProof',
    }),
    component: BillingPage,
  },
  {
    label: 'Hóa đơn',
    path: '/sale/billing',
    exact: true,
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'operation',
      feature: 'operationBill',
    }),
    component: BillingPage,
  },
  {
    label: 'Thu - Chi',
    path: '/debt/receipts',
    exact: true,
    hidding: !checkPermission({
      permissions,
      module: 'accounting',
      groupFeature: 'cashBook',
      feature: 'cashBookBill',
    }),
    component: ReceiptsPage,
  },
  {
    label: 'Thu - Chi',
    path: '/debt/payment',
    exact: true,
    component: PaymentPage,
    hidding: !checkPermission({
      permissions,
      module: 'accounting',
      groupFeature: 'cashBook',
      feature: 'cashBookPayment',
    }),
  },
  {
    label: 'Thu nợ',
    path: '/debt/collection',
    exact: true,
    hidding: !checkPermission({
      permissions,
      module: 'accounting',
      groupFeature: 'bill',
      feature: 'billDebt',
    }),
    component: CollectionPage,
  },
  {
    label: 'Đổi trả hàng',
    path: '/debt/returns',
    exact: true,
    hidding: !checkPermission({
      permissions,
      module: 'accounting',
      groupFeature: 'bill',
      feature: 'billProof',
    }),
    component: ReturnPage,
  },
  {
    label: 'Đổi trả hàng',
    path: '/sale/returns',
    exact: true,
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'operation',
      feature: 'operationReturn',
    }),
    component: ReturnPage,
  },
  {
    label: 'Hóa đơn/Danh mục hóa đơn',
    path: '/debt/categories',
    exact: true,
    hidding: !checkPermission({
      permissions,
      module: 'accounting',
      groupFeature: 'bill',
      feature: 'billProof',
    }),
    component: CategoriesPage,
  },
  {
    label: 'Hóa đơn',
    exact: true,
    path: '/debt/billing/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'accounting',
      groupFeature: 'bill',
      feature: 'billProof',
    }),
    component: UpdateBillingPage,
  },
  {
    label: 'Công nợ/Thống kê',
    exact: true,
    path: '/debt/statistics',
    component: DebtStatisticPage,
  },
  {
    label: 'Báo cáo công nợ',
    exact: true,
    path: '/report/debt',
    hidding: !checkPermission({
      permissions,
      module: 'overview',
      groupFeature: 'report',
      feature: 'reportDebt',
    }),
    component: DebtReportPage,
  },
  {
    label: 'Báo cáo doanh thu',
    exact: true,
    path: '/report/revenue',
    hidding: !checkPermission({
      permissions,
      module: 'overview',
      groupFeature: 'report',
      feature: 'reportRevenue',
    }),
    component: RevenueReportPage,
  },
  {
    label: 'Báo cáo bán hàng',
    exact: true,
    path: '/report/sale',
    hidding: !checkPermission({
      permissions,
      module: 'overview',
      groupFeature: 'report',
      feature: 'reportSale',
    }),
    component: SaleReportPage,
  },
  {
    label: 'Thiết lập/Thông tin website',
    path: '/settings/decoration',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingWebsite',
      feature: 'settingWebsiteInformation',
    }),
    component: SaleEntityDecorationPage,
  },
  {
    label: 'Thiết lập/Banner',
    path: '/settings/banner',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingWebsite',
      feature: 'settingWebsiteBanner',
    }),
    component: BannerListPage,
  },
  {
    label: 'Sản phẩm',
    path: '/product/list',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'resource',
      feature: 'resourceProduction',
    }),
    component: ProductListPage,
  },
  {
    label: 'Quản lý kho',
    path: '/inventory-product/list',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'warehouse',
      feature: 'warehouseProduct',
    }),
    component: InventoryProductListPage,
  },
  {
    label: 'Quản lý kho',
    path: '/inventory-product/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'warehouse',
      feature: 'warehouseProduct',
    }),
    component: InventoryProductDetailPage,
  },
  {
    label: 'Vật phẩm',
    path: '/sub-product/list',
    component: SubProductListPage,
  },
  {
    label: 'Sản phẩm',
    path: '/product/sync',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'resource',
      feature: 'resourceProduction',
    }),
    component: SyncProductPage,
  },
  {
    label: 'Sản phẩm',
    path: '/product/sync-diaries',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'resource',
      feature: 'resourceProduction',
    }),
    component: SyncEntityProductDiaryPage,
  },
  ...(canCreateNewProduct
    ? [
        {
          label: 'Sản phẩm',
          path: '/product/create',
          hidding: !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'resource',
            feature: 'resourceProduction',
          }),
          component: ProductCreatePage,
        },
      ]
    : []),
  {
    label: 'Sản phẩm',
    path: '/product/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'resource',
      feature: 'resourceProduction',
    }),
    component: ProductDetailPage,
  },
  {
    label: 'Sản phẩm/Danh mục sản phẩm',
    path: '/product/entity-category/list',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'resource',
      feature: 'resourceProduction',
    }),
    component: EntityCategoryPage,
  },
  {
    label: 'Vật tư/Danh mục vật tư',
    path: '/entity-material/entity-material-category/list',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'warehouse',
      feature: 'warehouseMaterial',
    }),
    component: EntityMaterialCategoryListPage,
  },
  {
    label: 'Vật tư',
    path: '/entity-material/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'warehouse',
      feature: 'warehouseMaterial',
    }),
    component: EntityMaterialDetailPage,
  },
  {
    label: 'Vật tư',
    path: '/entity-material/create',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'warehouse',
      feature: 'warehouseMaterial',
    }),
    component: EntityMaterialCreatePage,
  },
  {
    label: 'Vật tư',
    path: '/entity-material/list',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'warehouse',
      feature: 'warehouseMaterial',
    }),
    component: EntityMaterialListPage,
  },
  {
    label: 'Vùng sản xuất',
    path: '/area/list',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'resource',
      feature: 'resourceArea',
    }),
    component: AreaListPage,
  },
  {
    label: 'Vùng sản xuất',
    path: '/area/sync',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'resource',
      feature: 'resourceArea',
    }),
    component: SyncEntityAreaPage,
  },
  ...(canCreateNewProduct
    ? [
        {
          label: 'Vùng sản xuất',
          path: '/area/create',
          hidding: !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'resource',
            feature: 'resourceArea',
          }),
          component: AreaCreatePage,
        },
      ]
    : []),
  {
    label: 'Vùng sản xuất',
    path: '/area/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'resource',
      feature: 'resourceArea',
    }),
    component: AreaDetailPage,
  },

  {
    label: 'Kế hoạch sản xuất',
    path: '/production-plan/list',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'manufacturerUtil',
      feature: 'manufacturerUtilProductionPlan',
    }),
    component: ProductionPlanListPage,
  },
  {
    label: 'Kế hoạch sản xuất',
    path: '/production-plan/create',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'manufacturerUtil',
      feature: 'manufacturerUtilProductionPlan',
    }),
    component: ProductionPlanCreatePage,
  },
  {
    label: 'Kế hoạch sản xuất',
    path: '/production-plan/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'manufacturerUtil',
      feature: 'manufacturerUtilProductionPlan',
    }),
    component: ProductionPlanUpdatePage,
  },
  {
    label: 'Đối tượng trồng trọt',
    path: '/field-plant/list',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'diary',
      feature: 'diaryProductObject',
    }),
    render: (props: any) => (
      <ProductObjectListPageWithType {...props} type={0} />
    ),
  },
  {
    label: 'Đối tượng trồng trọt',
    path: '/field-plant/sync',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'diary',
      feature: 'diaryProductObject',
    }),
    component: SyncEntityProductObjectPage,
  },
  {
    label: 'Đối tượng trồng trọt',
    path: '/field-plant/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'diary',
      feature: 'diaryProductObject',
    }),
    render: (props: any) => (
      <ProductObjectDetailPageWithType {...props} type={0} />
    ),
  },
  ...(canCreateNewProduct
    ? [
        {
          label: 'Đối tượng trồng trọt',
          path: '/field-plant/:entityProductID/create',
          hidding: !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'diary',
            feature: 'diaryProductObject',
          }),
          render: (props: any) => (
            <ProductObjectCreatePageWithType {...props} type={0} />
          ),
        },
        {
          label: 'Đối tượng trồng trọt',
          path: '/field-plant/create',
          hidding: !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'diary',
            feature: 'diaryProductObject',
          }),
          render: (props: any) => (
            <ProductObjectCreatePageWithType {...props} type={0} />
          ),
        },
        {
          label: 'Đối tượng trồng trọt/Mùa vụ',
          path: '/field-plant/:id/section/create',
          hidding: !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'diary',
            feature: 'diaryProductObject',
          }),
          render: (props: any) => (
            <SectionCreatePageWithType {...props} type={0} />
          ),
        },
        {
          label: 'Đối tượng theo vùng/Mùa vụ',
          path: '/field-plant/:id/section/sync',
          hidding: !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'diary',
            feature: 'diaryProductObject',
          }),
          render: (props: any) => <SyncEntitySectionPage {...props} />,
        },
      ]
    : []),
  {
    label: 'Đối tượng trồng trọt/Mùa vụ',
    path: '/field-plant/:id/section/update/:entitySectionID',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'diary',
      feature: 'diaryProductObject',
    }),
    render: (props: any) => <SectionUpdatePageWithType {...props} type={0} />,
  },
  {
    label: 'Đối tượng chăn nuôi',
    path: '/farming-plant/list',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'diary',
      feature: 'diaryProductObject',
    }),
    render: (props: any) => (
      <ProductObjectListPageWithType {...props} type={1} />
    ),
  },
  {
    label: 'Đối tượng chăn nuôi',
    path: '/farming-plant/sync',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'diary',
      feature: 'diaryProductObject',
    }),
    component: SyncEntityProductObjectPage,
  },
  {
    label: 'Đối tượng chăn nuôi',
    path: '/farming-plant/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'diary',
      feature: 'diaryProductObject',
    }),
    render: (props: any) => (
      <ProductObjectDetailPageWithType {...props} type={1} />
    ),
  },
  ...(canCreateNewProduct
    ? [
        {
          label: 'Đối tượng chăn nuôi/Mùa vụ',
          path: '/farming-plant/:id/section/create',
          hidding: !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'diary',
            feature: 'diaryProductObject',
          }),
          render: (props: any) => (
            <SectionCreatePageWithType {...props} type={1} />
          ),
        },
        {
          label: 'Đối tượng chăn nuôi',
          path: '/farming-plant/:entityProductID/create',
          hidding: !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'diary',
            feature: 'diaryProductObject',
          }),
          render: (props: any) => (
            <ProductObjectCreatePageWithType {...props} type={0} />
          ),
        },
        {
          label: 'Đối tượng chăn nuôi',
          path: '/farming-plant/create',
          hidding: !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'diary',
            feature: 'diaryProductObject',
          }),
          render: (props: any) => (
            <ProductObjectCreatePageWithType {...props} type={1} />
          ),
        },
        {
          label: 'Đối tượng chăn nuôi/Mùa vụ',
          path: '/farming-plant/:id/section/sync',
          hidding: !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'diary',
            feature: 'diaryProductObject',
          }),
          render: (props: any) => <SyncEntitySectionPage {...props} />,
        },
      ]
    : []),
  {
    label: 'Đối tượng chăn nuôi/Mùa vụ',
    path: '/farming-plant/:id/section/update/:entitySectionID',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'diary',
      feature: 'diaryProductObject',
    }),
    render: (props: any) => <SectionUpdatePageWithType {...props} type={1} />,
  },
  {
    label: 'Đối tượng sản xuất',
    path: '/production-plant/list',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'diary',
      feature: 'diaryProductObject',
    }),
    render: (props: any) => (
      <ProductObjectListPageWithType {...props} type={2} />
    ),
  },
  {
    label: 'Đối tượng sản xuất',
    path: '/production-plant/sync',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'diary',
      feature: 'diaryProductObject',
    }),
    component: SyncEntityProductObjectPage,
  },
  {
    label: 'Đối tượng sản xuất',
    path: '/production-plant/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'diary',
      feature: 'diaryProductObject',
    }),
    render: (props: any) => (
      <ProductObjectDetailPageWithType {...props} type={2} />
    ),
  },
  ...(canCreateNewProduct
    ? [
        {
          label: 'Đối tượng sản xuất',
          path: '/production-plant/:entityProductID/create',
          hidding: !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'diary',
            feature: 'diaryProductObject',
          }),
          render: (props: any) => (
            <ProductObjectCreatePageWithType {...props} type={0} />
          ),
        },
        {
          label: 'Đối tượng sản xuất',
          path: '/production-plant/create',
          hidding: !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'diary',
            feature: 'diaryProductObject',
          }),
          render: (props: any) => (
            <ProductObjectCreatePageWithType {...props} type={2} />
          ),
        },
        {
          label: 'Đối tượng sản xuất/Mùa vụ',
          path: '/production-plant/:id/section/create',
          hidding: !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'diary',
            feature: 'diaryProductObject',
          }),
          render: (props: any) => (
            <SectionCreatePageWithType {...props} type={2} />
          ),
        },
        {
          label: 'Đối tượng sản xuất/Mùa vụ',
          path: '/production-plant/:id/section/sync',
          hidding: !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'diary',
            feature: 'diaryProductObject',
          }),
          render: (props: any) => <SyncEntitySectionPage {...props} />,
        },
      ]
    : []),
  {
    label: 'Đối tượng sản xuất/Mùa vụ',
    path: '/production-plant/:id/section/update/:entitySectionID',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'diary',
      feature: 'diaryProductObject',
    }),
    render: (props: any) => <SectionUpdatePageWithType {...props} type={2} />,
  },
  {
    label: 'Thêm nhật ký',
    path: '/add-diary',
    render: (props: any) => <AddDiaryMobile />,
  },
  {
    label: 'Đối tượng',
    path: '/product-object/:entityProductID/list',
    render: (props: any) => <ProductObjectMobile {...props} />,
  },
  {
    label: 'Đối tượng',
    path: '/product-object/list',
    render: (props: any) => <ProductObjectMobile {...props} />,
  },
  {
    label: 'Quy trình',
    path: '/process/list',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'resource',
      feature: 'resourceProcess',
    }),
    component: ProcessListPage,
  },
  {
    label: 'Quy trình',
    path: '/process/sync',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'resource',
      feature: 'resourceProcess',
    }),
    component: SyncEntityProcessPage,
  },
  ...(canCreateNewProduct
    ? [
        {
          label: 'Quy trình',
          path: '/process/create',
          hidding: !checkPermission({
            permissions,
            module: 'manufacturer',
            groupFeature: 'resource',
            feature: 'resourceProcess',
          }),
          component: ProcessCreatePage,
        },
      ]
    : []),
  {
    label: 'Quy trình',
    path: '/process/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'resource',
      feature: 'resourceProcess',
    }),
    component: ProcessDetailPage,
  },
  {
    label: 'Đối tác',
    exact: true,
    path: '/partner',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerCustomer',
    }),
    component: PartnerPage,
  },
  {
    label: 'Đối tác',
    exact: true,
    path: '/partner/list',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerCustomer',
    }),
    component: PartnerPage,
  },
  {
    label: 'Tổng quan đối tác',
    exact: true,
    path: '/partner/overview',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerCustomer',
    }),
    component: PartnerOverviewPage,
  },
  {
    label: 'Chi nhánh cửa hàng',
    exact: true,
    path: '/branch',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerBranch',
    }),
    component: BranchPage,
  },
  {
    label: 'Thiết lập/Chi nhánh cửa hàng',
    exact: true,
    path: '/settings/enterprise-branch',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessBranch',
    }),
    component: BranchPage,
  },
  {
    label: 'Thiết lập/Chi nhánh cửa hàng',
    exact: true,
    path: '/settings/enterprise-branch/list',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessBranch',
    }),
    component: BranchPage,
  },
  {
    label: 'Đối tác',
    exact: true,
    path: '/partner/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerCustomer',
    }),
    component: PartnerDetailPage,
  },
  {
    label: 'Đối tác/Quản lý phân loại',
    exact: true,
    path: '/partner/segment/list',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerCustomer',
    }),
    component: PartnerSegmentPage,
  },
  {
    label: 'Chi nhánh cửa hàng',
    exact: true,
    path: '/branch/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerBranch',
    }),
    component: PartnerDetailPage,
  },
  {
    label: 'Chi nhánh cửa hàng/Quản lý phân loại',
    exact: true,
    path: '/branch/segment/list',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerBranch',
    }),
    component: PartnerSegmentPage,
  },
  {
    label: 'Thiết lập/Chi nhánh cửa hàng',
    exact: true,
    path: '/settings/enterprise-branch/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessBranch',
    }),
    component: PartnerDetailPage,
  },
  {
    label: 'Nhà cung cấp',
    exact: true,
    path: '/supplier',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'supplier',
      feature: 'supplierSupplier',
    }),
    component: SupplierPage,
  },
  {
    label: 'Nhà cung cấp/Quản lý phân loại',
    exact: true,
    path: '/supplier/segment/list',
    component: SupplierSegmentListPage,
  },
  {
    label: 'Tổng quan nhà cung cấp',
    exact: true,
    path: '/supplier/overview',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'supplier',
      feature: 'supplierSupplier',
    }),
    component: SupplierOverviewPage,
  },
  {
    label: 'Chi nhánh sản xuất',
    exact: true,
    path: '/warehouse',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'supplier',
      feature: 'supplierWarehouse',
    }),
    component: WarehousePage,
  },
  {
    label: 'Chi nhánh sản xuất',
    exact: true,
    path: '/warehouse/list',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'supplier',
      feature: 'supplierWarehouse',
    }),
    component: WarehousePage,
  },
  {
    label: 'Chi nhánh sản xuất',
    exact: true,
    path: '/enterprise-warehouse',
    component: WarehousePage,
  },
  {
    label: 'Chi nhánh sản xuất/Quản lý phân loại',
    exact: true,
    path: '/warehouse/segment/list',
    component: SupplierSegmentListPage,
  },
  {
    label: 'Thiết lập/Chi nhánh sản xuất',
    exact: true,
    path: '/settings/enterprise-warehouse/list',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessWarehouse',
    }),
    component: WarehousePage,
  },
  {
    label: 'Nhà cung cấp',
    exact: true,
    path: '/supplier/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'supplier',
      feature: 'supplierSupplier',
    }),
    component: PartnerDetailPage,
  },
  {
    label: 'Chi nhánh sản xuất',
    exact: true,
    path: '/warehouse/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'supplier',
      feature: 'supplierWarehouse',
    }),
    component: PartnerDetailPage,
  },
  {
    label: 'Thiết lập/Chi nhánh sản xuất',
    exact: true,
    path: '/settings/enterprise-warehouse/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessWarehouse',
    }),
    component: PartnerDetailPage,
  },
  {
    label: 'Liên hệ bán hàng',
    path: '/sale-contact',
    exact: true,
    component: SaleContactPage,
  },
  {
    label: 'Khách hàng',
    exact: true,
    path: '/customer',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerCustomerUser',
    }),
    component: CustomerPage,
  },
  {
    label: 'Khách hàng',
    exact: true,
    path: '/customer/list',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerCustomerUser',
    }),
    component: CustomerPage,
  },
  {
    label: 'Khách hàng',
    exact: true,
    path: '/customer/create',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerCustomerUser',
    }),
    component: CustomerCreatePage,
  },
  {
    label: 'Khách hàng',
    exact: true,
    path: '/customer/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerCustomerUser',
    }),
    component: CustomerDetailPage,
  },
  {
    label: 'Khách hàng',
    exact: true,
    path: '/customer/:id/crm',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerCustomerUser',
    }),
    component: CustomerCRMPage,
  },
  {
    label: 'Khách hàng/Quản lý phân loại',
    exact: true,
    path: '/customer/segment/list',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerCustomerUser',
    }),
    component: CustomerSegmentPage,
  },
  {
    label: 'Liên kết',
    exact: true,
    path: '/partner/linked/:id/detail',
    component: PartnerDetailPage,
  },
  {
    label: 'Nhà cung cấp',
    exact: true,
    path: '/supplier/:id/crm',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'supplier',
      feature: 'supplierSupplier',
    }),
    component: PartnerCRMPage,
  },
  {
    label: 'Đối tác',
    exact: true,
    path: '/partner/:id/crm',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerCustomer',
    }),
    component: PartnerCRMPage,
  },
  {
    label: 'Chi nhánh sản xuất',
    exact: true,
    path: '/warehouse/:id/crm',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'supplier',
      feature: 'supplierWarehouse',
    }),
    component: PartnerCRMPage,
  },
  {
    label: 'Thiết lập/Chi nhánh sản xuất',
    exact: true,
    path: '/settings/enterprise-warehouse/:id/crm',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessWarehouse',
    }),
    component: PartnerCRMPage,
  },
  {
    label: 'Chi nhánh cửa hàng',
    exact: true,
    path: '/branch/:id/crm',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerBranch',
    }),
    component: PartnerCRMPage,
  },
  {
    label: 'Thiết lập/Chi nhánh cửa hàng',
    exact: true,
    path: '/settings/enterprise-branch/:id/crm',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessBranch',
    }),
    component: PartnerCRMPage,
  },
  {
    label: 'Liên kết/Chờ liên kết',
    exact: true,
    path: '/partner/waiting',
    component: PartnerWaitingForApprovalPage,
  },
  {
    label: 'Liên kết/Chờ phê duyệt',
    exact: true,
    path: '/partner/waiting/:id/detail',
    component: PartnerDetailPage,
  },
  {
    label: 'Liên kết/Chờ xác nhận',
    path: '/partner/pending',
    component: PartnerWaitForApprovalPage,
  },
  {
    label: 'Liên kết/Yêu cầu liên kết',
    path: '/partner/request',
    component: PartnerRequestPage,
  },

  {
    label: 'Thiết lập/Chính sách giá bán',
    path: '/settings/price-policy/list',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingPolicy',
      feature: 'settingPolicyPrice',
    }),
    component: PricePolicyPage,
  },
  {
    label: 'Thiết lập/Chính sách giá bán',
    path: '/settings/price-policy/create',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingPolicy',
      feature: 'settingPolicyPrice',
    }),
    component: CreatePricePolicyPage,
  },
  {
    label: 'Thiết lập/Chính sách giá bán',
    path: '/settings/price-policy/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingPolicy',
      feature: 'settingPolicyPrice',
    }),
    component: DetailPricePolicyPage,
  },
  {
    label: 'Thiết lập/Chính sách giá bán',
    path: '/settings/price-policy/overview',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingPolicy',
      feature: 'settingPolicyPrice',
    }),
    component: PricePolicyOverviewPage,
  },
  {
    label: 'Thiết lập/Chính sách dự báo',
    path: '/settings/forecast-policy/list',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingPolicy',
      feature: 'settingPolicyProposal',
    }),
    component: ProposalPolicyPage,
  },
  {
    label: 'Thiết lập/Chính sách dự báo',
    path: '/settings/forecast-policy/create',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingPolicy',
      feature: 'settingPolicyProposal',
    }),
    component: CreateProposalPolicyPage,
  },
  {
    label: 'Thiết lập/Chính sách dự báo',
    path: '/settings/forecast-policy/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingPolicy',
      feature: 'settingPolicyProposal',
    }),
    component: DetailProposalPolicyPage,
  },
  {
    label: '',
    path: '/order/overview/:id/detail',
    component: OrderDetailPage,
  },
  {
    label: 'Đơn hàng bán',
    path: '/sale-order-closing/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'operation',
      feature: 'operationOrder',
    }),
    component: OrderDetailPage,
  },
  {
    label: 'Đơn hàng/Đơn hàng chờ',
    path: '/sale-order-closing/sale-order-draft/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'operation',
      feature: 'operationOrder',
    }),
    component: OrderDetailPage,
  },
  {
    label: 'Thu mua/Tổng quan',
    path: '/purchase/overview',
    component: DashboardPage,
  },
  {
    label: 'Đơn nhập hàng',
    exact: true,
    path: '/buying-chain-order',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'purchase',
      feature: 'purchaseBuy',
    }),
    component: BuyingOrderPage,
  },
  {
    label: 'Kiểm kho',
    exact: true,
    path: '/stock-adjustments',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'purchase',
      feature: 'purchaseBuy',
    }),
    component: StockAdjustmentPage,
  },
  {
    label: 'Kiểm kho',
    exact: true,
    path: '/stock-adjustments/list',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'purchase',
      feature: 'purchaseBuy',
    }),
    component: StockAdjustmentPage,
  },
  {
    label: 'Kiểm kho',
    exact: true,
    path: '/stock-adjustments/create',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'purchase',
      feature: 'purchaseBuy',
    }),
    component: StockAdjustmentCreatePage,
  },
  {
    label: 'Kiểm kho',
    exact: true,
    path: '/stock-adjustments/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'purchase',
      feature: 'purchaseBuy',
    }),
    component: StockAdjustmentDetailPage,
  },
  {
    label: 'Đơn nhập hàng',
    path: '/buying-chain-order/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'purchase',
      feature: 'purchaseBuy',
    }),
    component: OrderDetailPage,
  },
  {
    label: 'Danh sách phân công',
    exact: true,
    path: '/assign-purchase-task',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'purchase',
      feature: 'purchaseAssign',
    }),
    component: AssignPurchaseTaskPage,
  },
  {
    label: 'Danh sách phân công',
    exact: true,
    path: '/assign-purchase-task/list',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'purchase',
      feature: 'purchaseAssign',
    }),
    component: AssignPurchaseTaskPage,
  },
  {
    label: 'Danh sách phân công',
    exact: true,
    path: '/assign-purchase-task/create',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'purchase',
      feature: 'purchaseAssign',
    }),
    component: AssignPurchaseTaskCreate,
  },
  {
    label: 'Danh sách phân công',
    exact: true,
    path: '/assign-purchase-task/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'purchase',
      feature: 'purchaseAssign',
    }),
    component: AssignPurchaseTaskUpdate,
  },
  {
    label: 'Đơn nhập hàng/Đơn chờ nhập',
    path: '/buying-chain-order/purchase-order-draft/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'warehouse',
      groupFeature: 'purchase',
      feature: 'purchaseBuy',
    }),
    component: OrderDetailPage,
  },
  {
    label: 'Thiết lập đặt hàng',
    path: '/purchase/buying-supplier',
    component: SupplierPage,
  },
  {
    label: 'Thiết lập/Thiết lập đặt hàng',
    exact: true,
    path: '/settings/buying-setting',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingOperation',
      feature: 'settingOperationAutoOrder',
    }),
    component: SettingBuyingPage,
  },
  {
    label: 'Thiết lập/Thiết lập đặt hàng',
    exact: true,
    path: '/settings/buying-setting/list',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingOperation',
      feature: 'settingOperationAutoOrder',
    }),
    component: SettingBuyingPage,
  },
  {
    label: 'Thiết lập/Thiết lập đặt hàng',
    exact: true,
    path: '/settings/buying-setting/history',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingOperation',
      feature: 'settingOperationAutoOrder',
    }),
    component: SettingBuyingHistoryPage,
  },
  {
    label: 'Thiết lập/Thiết lập vận hành',
    path: '/settings/entity-setting/chain-setting',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingOperation',
      feature: 'settingOperationAutoOrder',
    }),
    component: SettingBusinessPage,
  },

  {
    label: 'Đơn hàng bán',
    exact: true,
    path: '/sale-order-closing',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'operation',
      feature: 'operationOrder',
    }),
    component: OrderClosingPage,
  },
  {
    label: 'Đơn hàng/Đơn hàng chờ',
    exact: true,
    path: '/sale-order-closing/sale-order-draft',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'operation',
      feature: 'operationOrder',
    }),
    component: OrderPendingBuySalePage,
  },
  {
    label: 'Đơn hàng/Đơn hàng chờ',
    exact: true,
    path: '/sale-order-closing/sale-order-draft/list',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'operation',
      feature: 'operationOrder',
    }),
    component: OrderPendingBuySalePage,
  },
  {
    label: 'Bán hàng',
    exact: true,
    path: '/sale/#/',
    hidding:
      !checkPermission({
        permissions,
        module: 'sale',
        groupFeature: 'pos',
      }) &&
      !checkPermission({
        permissions,
        module: 'sale',
        groupFeature: 'operation',
        feature: 'operationBill',
      }) &&
      !checkPermission({
        permissions,
        module: 'sale',
        groupFeature: 'operation',
        feature: 'operationReturn',
      }) &&
      !checkPermission({
        permissions,
        module: 'sale',
        groupFeature: 'operation',
        feature: 'operationOrder',
      }) &&
      !checkPermission({
        permissions,
        module: 'accounting',
        groupFeature: 'bill',
        feature: 'billProof',
      }),
    component: SalePOSPage,
  },
  {
    label: 'Chia hàng',
    exact: true,
    path: '/sale/balance',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'operation',
      feature: 'operationSplitOrder',
    }),
    component: BalancePage,
  },
  {
    label: 'Đặt hàng',
    exact: true,
    path: '/purchase/order-chain-supplier',
    component: OrdersToChainSuppliersPage,
  },
  {
    label: 'Bán hàng',
    exact: true,
    path: '/sale',
    component: SalePOSPage,
  },
  {
    label: 'Thiết lập/Thiết lập dự báo',
    exact: true,
    path: '/settings/forecast-setting',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingOperation',
      feature: 'settingOperationAutoForecast',
    }),
    component: SettingForecastPage,
  },
  {
    label: 'Thiết lập/Thiết lập dự báo',
    exact: true,
    path: '/settings/forecast-setting/list',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingOperation',
      feature: 'settingOperationAutoForecast',
    }),
    component: SettingForecastPage,
  },
  {
    label: 'Danh sách giao hàng',
    exact: true,
    path: '/shipping-list',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'saleUtil',
      feature: 'saleUtilDeliveryList',
    }),
    component: EntityShippingListPage,
  },
  {
    label: 'Danh sách giao hàng',
    exact: true,
    path: '/shipping-list/list',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'saleUtil',
      feature: 'saleUtilDeliveryList',
    }),
    component: EntityShippingListPage,
  },
  {
    label: 'Danh sách giao hàng',
    exact: true,
    path: '/shipping-list/create',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'saleUtil',
      feature: 'saleUtilDeliveryList',
    }),
    component: EntityShippingCreatePage,
  },
  {
    label: 'Danh sách giao hàng',
    exact: true,
    path: '/shipping-list/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'saleUtil',
      feature: 'saleUtilDeliveryList',
    }),
    component: EntityShippingDetailPage,
  },
  {
    label: 'Danh sách phân công',
    exact: true,
    path: '/assign-task',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'saleUtil',
      feature: 'saleUtilAssignList',
    }),
    component: AssignTaskPage,
  },
  {
    label: 'Danh sách phân công',
    exact: true,
    path: '/assign-task/list',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'saleUtil',
      feature: 'saleUtilAssignList',
    }),
    component: AssignTaskPage,
  },
  {
    label: 'Danh sách phân công',
    exact: true,
    path: '/assign-task/create',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'saleUtil',
      feature: 'saleUtilAssignList',
    }),
    component: AssignTaskCreate,
  },
  {
    label: 'Danh sách phân công',
    exact: true,
    path: '/assign-task/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'saleUtil',
      feature: 'saleUtilAssignList',
    }),
    component: AssignTaskUpdate,
  },
  {
    label: 'Tổng hợp số lượng',
    path: '/sale/statistics-product',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'saleUtil',
      feature: 'saleUtilTotalQuantity',
    }),
    component: StatisticProductPage,
  },
  {
    label: 'Bán hàng/Dự báo sản lượng',
    exact: true,
    path: '/sale/forecast',
    component: ReportQuantityPage,
  },
  {
    label: 'Thiết lập/Thiết lập dự báo',
    exact: true,
    path: '/settings/forecast-setting/history',
    component: SettingForecastHistoryPage,
  },
  {
    label: 'Bán hàng/Dự báo sản lượng',
    exact: true,
    path: '/sale/quick-forecast',
    component: ForecastQuantityPage,
  },
  {
    label: 'Tạo sản phẩm',
    path: '/purchase/product-create',
    component: ProductCreatePage,
  },
  {
    label: 'Thiết lập/Mua chung',
    path: '/settings/co-buy/list',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingDiscount',
      feature: 'settingDiscountCobuy',
    }),
    component: CoBuyListPage,
  },
  {
    label: 'Thiết lập/Mua chung',
    path: '/settings/co-buy/create',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingDiscount',
      feature: 'settingDiscountCobuy',
    }),
    component: CoBuyCreatePage,
  },
  {
    label: 'Thiết lập/Mua chung',
    path: '/settings/co-buy/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingDiscount',
      feature: 'settingDiscountCobuy',
    }),
    component: CoBuyDetailPage,
  },
  {
    label: 'Thiết lập/Mua chung',
    path: '/settings/co-buy/report',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingDiscount',
      feature: 'settingDiscountCobuy',
    }),
    component: CoBuyReportPage,
  },
  {
    label: 'Thiết lập/Chiết khấu',
    path: '/settings/discount/list',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingDiscount',
      feature: 'settingDiscountCobuy',
    }),
    component: DiscountListPage,
  },
  {
    label: 'Thiết lập/Chiết khấu',
    path: '/settings/discount/create',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingDiscount',
      feature: 'settingDiscountCobuy',
    }),
    component: DiscountCreatePage,
  },
  {
    label: 'Thiết lập/Chiết khấu',
    path: '/settings/discount/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingDiscount',
      feature: 'settingDiscountCobuy',
    }),
    component: DiscountDetailPage,
  },
  {
    label: 'Thiết lập/Cấu hình khuyến mại',
    path: '/settings/discount-setting',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingDiscount',
      feature: 'settingDiscountCobuy',
    }),
    component: DiscountSettingPage,
  },
  {
    label: 'Kênh marketing/Menu đặt hàng',
    path: '/marketing/wholesale-menu/list',
    component: WholesaleDigitalMenuPage,
  },
  {
    label: 'Đối tác/Đồng bộ menu đặt hàng',
    path: '/partner/sync-menu',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerCustomer',
    }),
    component: SyncMenuProductPage,
  },
  {
    label: 'Chi nhánh cửa hàng/Đồng bộ menu đặt hàng',
    path: '/branch/sync-menu',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerBranch',
    }),
    component: SyncMenuProductPage,
  },
  {
    label: 'Thiết lập/Chi nhánh cửa hàng/Đồng bộ menu đặt hàng',
    path: '/settings/enterprise-branch/sync-menu',
    component: SyncMenuProductPage,
  },
  {
    label: 'Chi nhánh cửa hàng/Menu đặt hàng',
    path: '/branch/wholesale-menu/sync',
    hidding: !checkPermission({
      permissions,
      module: 'sale',
      groupFeature: 'customer',
      feature: 'customerBranch',
    }),
    component: SyncMenuProductPage,
  },
  {
    label: 'Kênh marketing/Menu đặt hàng',
    path: '/marketing/wholesale-menu/create',
    component: CreateWholesaleMenuPage,
  },
  {
    label: 'Kênh marketing/Menu đặt hàng',
    path: '/marketing/wholesale-menu/:id/detail',
    component: DetailWholesaleMenuPage,
  },
  {
    label: 'Thiết lập/Hình ảnh',
    path: '/settings/gallery/images',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingWebsite',
      feature: 'settingWebsiteGallery',
    }),
    component: GalleryPage,
  },
  {
    label: 'Thư viện/Tập tin',
    path: '/settings/gallery/files',
    component: SaleSpaceFilePage,
  },
  {
    label: 'Thiết lập',
    exact: true,
    path: '/settings',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
    }),
    component: ConfigPage,
  },
  {
    label: 'Thiết lập/Tài khoản thanh toán',
    path: '/settings/bank-account',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessBanking',
    }),
    component: BankAccountPage,
  },
  {
    label: 'Thông tin doanh nghiệp/Liên hệ',
    path: '/business/contact-tool',
    component: ContactToolPage,
  },
  {
    label: 'Thiết lập/Chính sách giảm giá',
    path: '/settings/delivery-fee',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingPolicy',
      feature: 'settingPolicyPromotion',
    }),
    component: DeliveryFeeSettingPage,
  },
  {
    label: 'Thiết lập/Chính sách giao hàng',
    path: '/settings/distance-shipping-fee',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingPolicy',
      feature: 'settingPolicyDelivery',
    }),
    component: DistanceShippingFeePage,
  },
  {
    label: 'Thiết lập/Sơ đồ phân hệ',
    path: '/settings/diagram',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessDiagram',
    }),
    component: EnterpriseSequenceDiagramPage,
  },
  {
    label: 'Thiết lập/Cá nhân thương hiệu',
    path: '/settings/custom-domain',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessCustom',
    }),
    component: CustomDomainPage,
  },

  {
    label: 'Thiết lập/Thông tin doanh nghiệp',
    path: '/settings/business',

    component: ContactInformationPage,
  },
  {
    label: 'Thiết lập/Vị trí giao hàng',
    path: '/settings/shipping-location',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingPolicy',
      feature: 'settingPolicyDelivery',
    }),
    component: ShippingLocationPage,
  },
  {
    label: 'Thiết lập/Chứng nhận',
    path: '/settings/certification',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingWebsite',
      feature: 'settingWebsiteCertificate',
    }),
    component: CertificationPage,
  },
  {
    label: 'Thiết lập/SEO Website',
    path: '/settings/seo',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingWebsite',
      feature: 'settingWebsiteSeo',
    }),
    component: SEOWebsitePage,
  },
  {
    exact: true,
    path: '/',
    component: DashboardPage,
  },
  {
    label: 'Giao dịch',
    exact: true,
    path: '/transaction',
    component: TransactionPage,
  },
  {
    label: 'Coupon',
    path: '/settings/coupon/list',
    component: MyCouponPage,
  },
  {
    label: 'Coupon',
    path: '/settings/coupon/create',
    component: CouponCreatePage,
  },
  {
    label: 'Coupon',
    path: '/settings/coupon/:id/detail',
    component: CouponDetailPage,
  },
  {
    label: 'Thiết lập/Chuỗi cửa hàng',
    path: '/settings/chain-stores/list',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessBranchObject',
    }),
    component: BranchListPage,
  },
  {
    label: 'Thiết lập/Bài viết',
    path: '/settings/blog',
    exact: true,
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessBranchObject',
    }),
    component: BlogListPage,
  },
  {
    label: 'Thiết lập/Bài viết',
    path: '/settings/blog/list',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessBranchObject',
    }),
    component: BlogListPage,
  },
  {
    label: 'Thiết lập/Bài viết',
    path: '/settings/blog/create',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessBranchObject',
    }),
    component: BlogCreatePage,
  },
  {
    label: 'Thiết lập/Bài viết',
    path: '/settings/blog/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessBranchObject',
    }),
    component: BlogDetailPage,
  },
  {
    label: 'Thiết lập/Bài viết/Danh mục',
    path: '/settings/blog/blog-category/list',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessBranchObject',
    }),
    component: BlogCategoryListPage,
  },
  {
    label: 'Thiết lập/Chuỗi cửa hàng',
    path: '/settings/chain-stores/create',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessBranchObject',
    }),
    component: BranchCreatePage,
  },
  {
    label: 'Thiết lập/Chuỗi cửa hàng',
    path: '/settings/chain-stores/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessBranchObject',
    }),
    component: BranchDetailPage,
  },
  {
    label: 'Tem truy xuất',
    path: '/stamp/list',
    hidding: !checkPermission({
      permissions,
      module: 'manufacturer',
      groupFeature: 'diary',
      feature: 'diaryStamp',
    }),
    component: StampListPage,
  },
  {
    label: 'Thiết lập/Nhân viên',
    path: '/settings/employee/list',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessEmployee',
    }),
    component: EmployeeListPage,
  },
  {
    label: 'Thiết lập/Nhân viên',
    path: '/settings/employee/create',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessEmployee',
    }),
    component: EmployeeCreatePage,
  },
  {
    label: 'Thiết lập/Nhân viên',
    path: '/settings/employee/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessEmployee',
    }),
    component: EmployeeDetailPage,
  },
  {
    label: 'Thiết lập/Mã giảm giá',
    path: '/settings/shop-coupons/list',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingDiscount',
      feature: 'settingDiscountDiscount',
    }),
    component: ShopCouponListPage,
  },
  {
    label: 'Thiết lập/Mã giảm giá',
    path: '/settings/product-coupons/list',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingDiscount',
      feature: 'settingDiscountDiscount',
    }),
    component: ShopCouponListPage,
  },
  {
    label: 'Thiết lập/Mã giảm giá',
    path: '/settings/shop-coupons/create',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingDiscount',
      feature: 'settingDiscountDiscount',
    }),
    component: ShopCouponCreatePage,
  },
  {
    label: 'Kênh marketing/Coupon sản phẩm',
    path: '/product-coupons/create',
    component: ShopCouponCreatePage,
  },
  {
    label: 'Thiết lập/Mã giảm giá',
    path: '/settings/shop-coupons/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingDiscount',
      feature: 'settingDiscountDiscount',
    }),
    component: ShopCouponDetailPage,
  },
  {
    label: 'Kênh marketing/Coupon sản phẩm',
    path: '/product-coupons/:id/detail',
    component: ShopCouponDetailPage,
  },
  {
    label: 'Kênh marketing/Miễn phí ship',
    exact: true,
    path: '/marketing/freeship-coupons/list',
    component: FreeshipCouponListPage,
  },
  {
    label: 'Kênh marketing/Miễn phí ship',
    path: '/marketing/freeship-coupons/create',
    component: FreeshipCouponCreatePage,
  },
  {
    label: 'Kênh marketing/Miễn phí ship',
    path: '/marketing/freeship-coupons/:id/detail',
    component: FreeshipCouponUpdatePage,
  },
  {
    label: 'Thiết lập/Combo',
    path: '/settings/combo/list',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingDiscount',
      feature: 'settingDiscountCombo',
    }),
    component: ComboListPage,
  },
  {
    label: 'Thiết lập/Combo',
    path: '/settings/combo/create',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingDiscount',
      feature: 'settingDiscountCombo',
    }),
    component: ComboCreatePage,
  },
  {
    label: 'Thiết lập/Combo',
    path: '/settings/combo/:id/detail',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingDiscount',
      feature: 'settingDiscountCombo',
    }),
    component: ComboDetailPage,
  },

  // * Kho
  {
    label: 'Thiết lập/Quản lý kho',
    path: '/settings/stock',
    hidding: !checkPermission({
      permissions,
      module: 'setting',
      groupFeature: 'settingBusiness',
      feature: 'settingBusinessBanking',
    }),
    component: StockListPage,
  },
];

export const defaultModuleRoutes: any = {
  sale: 'sale-order-closing',
  debt: 'debt/billing',
  report: 'report/revenue',
  purchase: 'purchase/buying-make-order',
  setting: 'entity-report/list',
  gallery: 'gallery/images',
  website: 'website/decoration',
  policy: 'policy/price-policy/list',
  statistics: 'statistics/revenue',
  partner: 'partner/request',
  notification: 'notification/overview/list',
  marketing: 'marketing/combo/list',
  product: 'product/list',
  customer: 'customer',
  branch: 'branch',
  'settings/enterprise-branch': 'settings/enterprise-branch/list',
  'entity-material': 'entity-material/list',
  'enterprise-model': 'enterprise-model/diagram',
  'field-plant': 'field-plant/list',
  'farming-plant': 'farming-plant/list',
  'production-plant': 'production-plant/list',
  'partner/waiting/list': 'partner/waiting',
  'zalo-notification': 'zalo-notification/list',
  settings: 'settings',
  'settings/blog': 'settings/blog',
  'buying-chain-order': 'buying-chain-order',
  'sale-order-closing': 'sale-order-closing',
  'sale-order-closing/sale-order-draft': 'sale-order-closing/sale-order-draft',
};

export const defaultOrderRoutes: string[] = [
  'sale-order-closing',
  'sale/sale-order-menu-share',
  'sale/sale-order-cobuy',
  'buying-chain-order',
  'customer',
  'branch',
  'supplier',
  'warehouse',
  'settings',
  'settings/blog',
  'partner/request',
  'statistics/revenue',
  'enterprise-branch',
];
